module.exports = __webpack_public_path__ + "static/img/prod-fashion2.3dbd1ca8.jpg";